import { ShopifyIcon } from '@/components/icons';
import { Alert } from '@/components/ui/alert';
import { useGetShopifyInstallUrl } from '@/hooks/actions/use-connect-shopify-action';
import { Box } from '@chakra-ui/react';
import { Cart, Gift, Label } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import { OnboardingContinueButton } from '../_components/OnboardingContinueButton';
import { ConnectFeatureList } from './ConnectFeatureList';
import { ConnectHeader } from './ConnectHeader';
import { shopifyConnectErrorMessage } from './shopify-connect-errors';

/**
 * Shopify connection through the existing install flow: the install URL is
 * asked for, then the browser leaves for Shopify and comes back through the
 * OAuth callback.
 */
export const ShopifyConnect = ({ error }: { error: string | null }) => {
  const { t } = useTranslation();
  const getInstallUrl = useGetShopifyInstallUrl();

  return (
    <>
      <ConnectHeader
        logo={<ShopifyIcon boxSize="26px" />}
        title={t('onboarding.shopify.title')}
        description={t('onboarding.shopify.description')}
      />

      {error && (
        <Box mt="16px">
          <Alert status="error" title={t('common.error')}>
            {shopifyConnectErrorMessage(error, t)}
          </Alert>
        </Box>
      )}

      <ConnectFeatureList
        features={[
          { icon: Cart, label: t('onboarding.shopify.features.orders') },
          { icon: Label, label: t('onboarding.shopify.features.discounts') },
          { icon: Gift, label: t('onboarding.shopify.features.gifting') },
        ]}
      />

      <OnboardingContinueButton
        loading={getInstallUrl.isPending}
        loadingText={t('onboarding.connect.connecting')}
        onClick={() => getInstallUrl.mutate()}
      >
        <ShopifyIcon boxSize="19px" />
        {t('onboarding.shopify.connectShopify')}
      </OnboardingContinueButton>
    </>
  );
};
